import React, { useState, useEffect } from 'react';

//Components
import MainCard from '../../components/MainCard/MainCard';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';
import FichaFormularioDeFiscalizacao from './FichaFormularioDeFiscalizacao';
import NovoFormularioDeFiscalizacao from './NovoFormularioDeFiscalizacao';
import Loading from '../../components/Loading/Loading';

//Constants
import { actionsTable } from '../../constants/MaterialTable';

//Api
import formularioVistoria_api from '../../api/formularioVistoria_api';
import { showMessage } from 'helpers/message';

export default function FormulariosDeFiscalizacao() {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle da tela de novo 
    const [novo, setNovo] = useState(false);

    //Estado de controle da tela de ficha
    const [ficha, setFicha] = useState(false);

    //Estado de controle da lista de formularios
    const [formularios, setFormularios] = useState();

    //Ações da tabela da lista de formularios
    const actions = [
        actionsTable.visualizar((rowData) => {
            setFicha(rowData.id)
        })
    ]

    //Função que carrega a lista de formularios cadastrados
    const carregaLista = () => {
        setLoading(true);
        formularioVistoria_api.GetList().then(response => {
            setFormularios(response.data.map(formulario => {
                formulario.ativo = formulario.ativo ? "Sim" : "Não";
                return formulario;
            }));
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    useEffect(() => {
        carregaLista();
    }, []);
    //Controle de exibição da tela de novo formulario
    if (novo)
        return <NovoFormularioDeFiscalizacao btnVoltar={() => {
            carregaLista();
            setNovo(false);
        }} />

    if (ficha) {
        return <FichaFormularioDeFiscalizacao btnVoltar={() => {
            carregaLista();
            setFicha(null);
        }} id={ficha} />
    }
    return (
        <MainCard noCard btnCadastro={"Adicionar"} onClickBtnCadastro={() => setNovo(true)}>
            {loading && <Loading />}
            <TabelaListagem title={"Lista de formularios de fiscalização"} headers={[
                { value: "Identificação", objectValue: "identificacao" },
                { value: "Ativo", objectValue: "ativo" },
            ]} items={formularios} actions={actions} />
        </MainCard>
    )
}